import ArrowForwardRoundedIcon from '@mui/icons-material/ArrowForwardRounded';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import { useTranslation } from 'react-i18next';
import { useOnboardingNavigate } from '@/hooks/useOnboardingNavigate';
import { COMMON_NAMESPACE } from '@/i18n';
import { trackWelcomeEvent } from '@/helpers/analytics';
import { welcomeCopy } from '@/Pages/Welcome/copy';
import '@/components/WelcomeCta/WelcomeCta.sass';

type WelcomeCtaProps = {
  label?: string;
  to?: string;
};

export function WelcomeCta({
  label = welcomeCopy.cta,
  to = '/terms',
}: WelcomeCtaProps): JSX.Element {
  const { t } = useTranslation(COMMON_NAMESPACE);
  const { navigateTo, isNavigating } = useOnboardingNavigate();

  const handleClick = () => {
    void trackWelcomeEvent({
      name: 'welcome_cta_click',
      params: { destination: to },
    });
    navigateTo(to);
  };

  return (
    <Box className="welcome-cta">
      <Button
        type="button"
        variant="contained"
        color="primary"
        fullWidth
        disabled={isNavigating}
        aria-busy={isNavigating}
        loading={isNavigating}
        className="welcome-cta__button"
        loadingIndicator={
          <CircularProgress
            size={22}
            aria-label={t('loading')}
            className="welcome-cta__loader"
          />
        }
        loadingPosition="end"
        onClick={handleClick}
        endIcon={
          isNavigating ? undefined : (
            <ArrowForwardRoundedIcon aria-hidden fontSize="small" />
          )
        }
      >
        {label}
      </Button>
    </Box>
  );
}
